import { useCallback, useMemo, useState } from 'react';
import { filterProjects } from '../lib/projectFilters';

export const useProjectFilters = (projects) => {
  const [filter, setFilter] = useState('Tumu');
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('big');
  const categories = useMemo(() => ['Tumu', ...new Set(projects.map((project) => project.category))], [projects]);
  const filtered = useMemo(() => filterProjects(projects, filter, search, sort), [projects, filter, search, sort]);
  const reset = useCallback(() => { setSearch(''); setFilter('Tumu'); }, []);
  return { filter, setFilter, search, setSearch, sort, setSort, categories, filtered, reset };
};